import { z } from 'zod';
import { PUBLIC_NETWORK_TYPE_LABELS } from '../inspection/survey-v2.js';
/**
 * `Site.sewer_network_type` — le **réseau public du dossier** ([M43](../../../../docs/MODELE-DONNEES.md#m43)) :
 * unitaire ou séparatif, tel que la liste du client ou le bureau le donne **avant** la visite.
 * C'est lui que l'agenda de la tablette annonce (« Réseau unitaire · Systématique »).
 *
 * ⚠️ **Ce n'est pas le réseau constaté**, `survey.plot.publicNetworkType`, que l'agent relève
 * sur place et qui décide des anomalies (`stormwaterAnomalies`). Les deux gardent chacun leur
 * valeur, comme la parcelle du dossier et celle constatée (M30) : rien ne recopie l'un dans
 * l'autre.
 *
 * Mêmes codes que le réseau constaté, et une liste **fermée** : un réseau public est l'un ou
 * l'autre. Inconnu, il vaut `null` — jamais une troisième valeur.
 */
export const SEWER_NETWORK_TYPES = ['combined', 'separate'];
export const sewerNetworkTypeSchema = z.enum(SEWER_NETWORK_TYPES);
/**
 * Les libellés du réseau du dossier — **ceux du réseau constaté** : le même mot pour la même
 * chose, et l'annotation de type fait tomber la compilation si les deux listes de codes divergent.
 */
export const SEWER_NETWORK_TYPE_LABELS = PUBLIC_NETWORK_TYPE_LABELS;
//# sourceMappingURL=sewer-network-type.js.map